document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".ib-tab__btn");
  const panels = document.querySelectorAll(".ib-tab__panel");

  function activate(tab) {
    buttons.forEach(b => b.classList.remove("is-active"));
    panels.forEach(p => p.classList.remove("is-active"));

    document.querySelector(`[data-tab="${tab}"]`)?.classList.add("is-active");
    document.querySelector(`[data-tab-panel="${tab}"]`)?.classList.add("is-active");
  }

  function handleHash() {
    if (location.hash === "#recover") {
      activate("login"); // recover lives inside login panel
      document.getElementById("recover")?.scrollIntoView();
      return;
    }

    if (location.hash === "#register") {
      activate("register");
      return;
    }

    activate("login");
  }

  handleHash();

  window.addEventListener("hashchange", handleHash);

  buttons.forEach(btn => {
    btn.addEventListener("click", () => {
      const tab = btn.dataset.tab;
      location.hash = tab === "register" ? "#register" : "#login";
    });
  });
});





// (function () {

//   function initAuthTabs() {
//     const wrapper = document.getElementById('ib-auth-section');
//     if (!wrapper) return;

//     wrapper.querySelectorAll('.ib-tab__btn').forEach(btn => {
//       btn.addEventListener('click', () => {
//         const tab = btn.dataset.tab;
//         const url = tab === 'register'
//           ? '/account/register'
//           : '/account/login';

//         history.pushState({ tab }, '', url);

//         loadFullPageSection(url);
//       });
//     });
//   }

//   function loadFullPageSection(url) {
//     fetch(url)
//       .then(res => res.text())
//       .then(html => {
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(html, 'text/html');

//         const newSection = doc.querySelector('#ib-auth-section');
//         const currentSection = document.querySelector('#ib-auth-section');

//         if (newSection && currentSection) {
//           // 🔥 Replace entire section INCLUDING IMAGE
//           currentSection.innerHTML = newSection.innerHTML;
//           initAuthTabs();
//         }
//       });
//   }

//   document.addEventListener('DOMContentLoaded', initAuthTabs);

//   window.addEventListener('popstate', () => {
//     loadFullPageSection(location.pathname);
//   });

// })();